export enum RequestStatus {
    New = 1,
    PartiallyApproved = 2,
    Approved = 3,
    Canceled = 4,
    Rejected = 5,
    Used = 6
}
